import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { theme } from 'lib/theme';
import React from 'react';
import { useSelector } from 'hooks/useSelector';
import {
  selectAseExplorerOptionShowValidationErrors,
  selectAseExplorerOptionSize,
  selectAseSignatoryResults,
  selectAseTplSignatories,
} from 'store/assessments/selectors';
import { Card } from 'components/Card';
import { ModalScreens } from 'components/Navigation/types';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL } from 'store/actions';
import { UID } from 'types/types';

export const ExplorerSignatories: React.FC = () => {
  const dispatch = useDispatch();
  const explorerOptionSize = useSelector(selectAseExplorerOptionSize);
  const signatories = useSelector(selectAseTplSignatories);
  const signatoryResults = useSelector(selectAseSignatoryResults);
  const showValidationErrors = useSelector(
    selectAseExplorerOptionShowValidationErrors,
  );
  const openSignatory = (signatoryId: UID) => {
    dispatch(
      NAVIGATE_MODAL({
        screen: ModalScreens.AseSignatory,
        params: {
          signatoryId,
        },
      }),
    );
  };

  if (!signatories.length) {
    return null;
  }

  return (
    <Card>
      {signatories.reduce<React.ReactElement[]>((acc, signatory) => {
        const result = signatoryResults[signatory.id];
        acc.push(
          <CardRow
            key={signatory.id}
            icon={ICONS.SignatureLight}
            iconColor={result ? theme.colors.green : undefined}
            label={signatory.name}
            label2={
              showValidationErrors && signatory.requireOnSubmit && !result
                ? 'Required signatory'
                : ''
            }
            label2Color={theme.colors.red}
            required={signatory.requireOnSubmit}
            placeholder="Not Set"
            value={result?.name || (result?.unavailable ? 'Unavailable' : '')}
            onPress={() => openSignatory(signatory.id)}
            compact={explorerOptionSize === 'small'}
            small={explorerOptionSize === 'small'}
          />,
        );
        return acc;
      }, [])}
    </Card>
  );
};
